import React from 'react';
import { SelectLabel } from '@weezevent/nacre';
import useAppContext from '../../../../../context/useAppContext';
import css from '../../styles.module.css';
import { useTranslatedLanguages } from '../../../../widgets/components/language-selector/language-selector';

export default function LanguageSelect({ language, languages = null, setLanguage, label = '', onOpen = () => {} }) {
    let [{ event }] = useAppContext();
    const languageOptions = useTranslatedLanguages(languages || event?.languages || []);

    const handleChange = React.useCallback(
        value => {
            setLanguage(value);
        },
        [setLanguage]
    );

    return (
        <SelectLabel
            onOpen={onOpen}
            className={css['select-labels-child-1']}
            label={label}
            placeholder={language}
            value={language}
            options={languageOptions}
            onChange={handleChange}
        />
    );
}
